export enum Pollutant {
  PM2_5 = 'PM2_5',
  PM10 = 'PM10',
  NO2 = 'NO2',
}
